import { render } from "./LiveWidgetsConfiguration.vue?vue&type=template&id=53262f2d&scoped=true"
import script from "./LiveWidgetsConfiguration.vue?vue&type=script&lang=js"
export * from "./LiveWidgetsConfiguration.vue?vue&type=script&lang=js"

import "./LiveWidgetsConfiguration.vue?vue&type=style&index=0&id=53262f2d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53262f2d"]])

export default __exports__